import { Link } from "react-router-dom";
import { Star, ArrowRight, MapPin } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { TESTIMONIALS } from "../../data";

function ReviewCard({ t }) {
  return (
    <figure
      className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-7 backdrop-blur-xl transition-colors duration-300 hover:border-blue-500/40"
      data-testid="review-card"
    >
      <div className="flex gap-1">
        {Array.from({ length: t.rating }).map((_, s) => (
          <Star key={s} className="h-4 w-4 fill-blue-500 text-blue-500" />
        ))}
      </div>
      <blockquote className="mt-5 flex-1 leading-relaxed text-slate-200">&ldquo;{t.text}&rdquo;</blockquote>
      <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-5">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-blue-600/15 font-display font-semibold text-blue-400">
          {t.name.charAt(0)}
        </div>
        <div>
          <p className="font-medium text-white">{t.name}</p>
          <p className="flex items-center gap-1.5 text-sm text-slate-500">
            {t.role}
            {t.country && (
              <>
                <span className="text-slate-700">·</span>
                <MapPin className="h-3 w-3" /> {t.country}
              </>
            )}
          </p>
        </div>
      </figcaption>
    </figure>
  );
}

export default function ClientReviews() {
  return (
    <div>
      <Carousel opts={{ align: "start", loop: true }} className="w-full">
        <div className="mb-8 flex items-center justify-end gap-3">
          <CarouselPrevious
            data-testid="reviews-prev"
            className="static h-11 w-11 translate-y-0 border-white/10 bg-white/5 text-white hover:bg-white/10 hover:text-white"
          />
          <CarouselNext
            data-testid="reviews-next"
            className="static h-11 w-11 translate-y-0 border-white/10 bg-white/5 text-white hover:bg-white/10 hover:text-white"
          />
        </div>
        <CarouselContent className="-ml-6">
          {TESTIMONIALS.map((t, i) => (
            <CarouselItem key={i} className="pl-6 sm:basis-1/2 lg:basis-1/3" data-testid={`review-item-${i}`}>
              <ReviewCard t={t} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>

      <div className="mt-12 flex justify-center">
        <Link
          to="/testimonials"
          data-testid="view-more-reviews-button"
          className="flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-8 py-4 font-medium text-white transition-all duration-300 hover:bg-white/10 hover:-translate-y-1"
        >
          View More Reviews <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
